import createReducer from 'store/createReducer'
import { ActionType, type Owners, type OwnerDataResponse } from 'store/owners/types'
import { Action, Nullable } from 'store/model'

export interface IOwnersReducer {
  owners: Nullable<Owners>
  owner: Nullable<OwnerDataResponse>
}

const defaultState: IOwnersReducer = {
  owners: null,
  owner: null,
}

export const ownersReducer = createReducer<IOwnersReducer>(defaultState, {
  [ActionType.SET_OWNERS]: (state: IOwnersReducer, action: Action<Nullable<Owners>>) => ({
    ...state,
    owners: action.payload,
  }),
  [ActionType.SET_OWNER]: (state: IOwnersReducer, action: Action<Nullable<OwnerDataResponse>>) => ({
    ...state,
    owner: action.payload,
  }),
})
